import { render } from "./Creacion-Grupo-Solidario.vue?vue&type=template&id=dced484e&scoped=true"
import script from "./Creacion-Grupo-Solidario.vue?vue&type=script&lang=js"
export * from "./Creacion-Grupo-Solidario.vue?vue&type=script&lang=js"

import "./Creacion-Grupo-Solidario.vue?vue&type=style&index=0&id=dced484e&scoped=true&lang=css"
import "./Creacion-Grupo-Solidario.vue?vue&type=style&index=1&id=dced484e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dced484e"]])

export default __exports__